import apiClient from "@/services/axios";

/**
 * In-memory cache for the Plan Comptable Tunisien.
 *
 * The endpoint returns a static dataset; the first request resolves the cache
 * and subsequent calls reuse it without hitting the network. The single
 * in-flight promise prevents duplicate concurrent fetches when several
 * components mount at the same time.
 */
let cache = null;
let inFlight = null;

export async function loadPlanComptable() {
  if (cache) return cache;
  if (!inFlight) {
    inFlight = apiClient
      .get("/compV3/depense/plan-comptable")
      .then((res) => {
        const data = res && res.data ? res.data : { tree: [], flat: [] };
        cache = {
          tree: Array.isArray(data.tree) ? data.tree : [],
          flat: Array.isArray(data.flat) ? data.flat : [],
        };
        return cache;
      })
      .catch((err) => {
        inFlight = null;
        throw err;
      });
  }
  return inFlight;
}

export function findPlanComptableNode(code) {
  if (!cache || !code) return null;
  const c = String(code).trim();
  return cache.flat.find((n) => String(n.code) === c) || null;
}

/** Returns a short label like "60 - Achats". Falls back to the code. */
export function describePlanComptableCode(code) {
  if (!code) return "";
  const node = findPlanComptableNode(code);
  if (!node) return String(code);
  return `${node.code} - ${node.label}`;
}

export function clearPlanComptableCache() {
  cache = null;
  inFlight = null;
}
